import * as React from 'react';

import { Button } from '../../../common/components/button';
import { DownloadExcelContainer } from './DownloadExcelContainer';
import { PrintPopupContainer } from './print_popup/container';
import { trackPrintOffersClicked } from './tracking';

const style = require('./index.css');

export interface IButtonPrintExcelGroupState {
  isPrintPopupVisible: boolean;
}

export class ButtonPrintExcelGroup extends React.Component<{}, IButtonPrintExcelGroupState> {
  public state = {
    isPrintPopupVisible: false,
  };

  public componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  public componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  public render() {
    return (
      <div className={style['buttonGroup']}>
        <DownloadExcelContainer />
        <Button theme="primary" mode="light" onClick={this.onPrintOffersClick}>
          Распечатать объявления
        </Button>
        <PrintPopupContainer open={this.state.isPrintPopupVisible} close={this.hidePrintPopup} />
      </div>
    );
  }

  private handleKeyDown = (e: KeyboardEvent) => {
    const KEY_CODE_P = 80;
    if (e.keyCode === KEY_CODE_P && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      this.showPrintPopup();
    }
  };

  private hidePrintPopup = () => {
    this.setState({
      isPrintPopupVisible: false,
    });
  };

  private showPrintPopup = () => {
    this.setState({
      isPrintPopupVisible: true,
    });
  };

  private onPrintOffersClick = () => {
    trackPrintOffersClicked();

    this.showPrintPopup();
  };
}
